import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/AppShell";
import { LegalFooter } from "../components/LegalFooter";

const DOCS = {
  privacy: ["Privacy e cookie", [
    ["Chi siamo", "Social Betting è un gioco online gratuito di pronostici sul calcio a punti virtuali. Il titolare del trattamento è il gestore del sito, contattabile tramite i recapiti indicati sul sito."],
    ["Dati che raccogliamo", "Nome, email e password (salvata in forma cifrata) per creare il tuo account; i pronostici, i tornei e le classifiche che crei usando il sito."],
    ["Perché li usiamo", "Per farti accedere, gestire i tornei, calcolare i punteggi e inviarti email di servizio (codice di recupero password e promemoria di consegna della schedina). Non vendiamo i tuoi dati."],
    ["Cookie tecnici", "Usiamo una memoria locale del browser per mantenerti collegato e ricordare la tua scelta sui cookie. Sono necessari al funzionamento e non richiedono consenso."],
    ["Pubblicità e cookie di terze parti", "Al momento il sito non mostra pubblicità e non carica cookie pubblicitari di terze parti. La scelta sui cookie resta salvata e puoi modificarla dal link «Gestisci cookie» in fondo alla pagina."],
    ["Conservazione e diritti", "Conserviamo i dati finché il tuo account è attivo. Puoi chiedere accesso, correzione o cancellazione dei tuoi dati scrivendo al gestore del sito. Hai diritto di reclamo al Garante per la protezione dei dati personali."],
  ]],
  termini: ["Termini d'uso", [
    ["Il servizio", "Social Betting è un gioco gratuito di pronostici sportivi a punti virtuali, simile al fantacalcio. Non è un servizio di scommesse e non prevede puntate o vincite in denaro o in natura."],
    ["Età minima", "Il sito è riservato ai maggiorenni (18+). Registrandoti dichiari di avere almeno 18 anni."],
    ["Account", "Sei responsabile della riservatezza della tua password e delle attività svolte con il tuo account. Usa un nome non offensivo."],
    ["Tornei", "Chi crea un torneo ne è l'admin e ne decide le regole. I punti sono virtuali, non hanno valore economico e non possono essere convertiti in denaro o premi."],
    ["Dati sportivi", "Calendari e risultati provengono da fornitori esterni e possono contenere ritardi o errori. Il calcolo dei punti segue il Regolamento pubblicato sul sito."],
    ["Pubblicità", "Il sito è finanziato da annunci pubblicitari. Il gestore non promuove giochi con vincita in denaro."],
    ["Modifiche e responsabilità", "Il servizio è fornito così com'è e può essere modificato o sospeso. Il gestore può aggiornare questi termini; la versione valida è sempre quella pubblicata su questa pagina."],
  ]],
};

export default function LegalPage({ doc: forced }) {
  const { doc: param } = useParams();
  const [title, sections] = DOCS[forced || param] || DOCS.termini;
  return (
    <div className="min-h-screen pitch-bg flex flex-col">
      <header className="border-b border-[#26334D]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Logo />
          <Link to="/" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white" data-testid="legal-back-link"><ArrowLeft size={16} /> Torna al sito</Link>
        </div>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-8 py-12 space-y-8">
        <h1 className="font-display text-4xl sm:text-5xl font-black uppercase tracking-tight" data-testid="legal-title">{title}</h1>
        {sections.map(([h, p]) => (
          <section key={h} className="space-y-2">
            <h2 className="font-display text-xl font-bold uppercase text-emerald-400">{h}</h2>
            <p className="text-sm text-slate-300 leading-relaxed">{p}</p>
          </section>
        ))}
        <p className="text-xs text-slate-500">Ultimo aggiornamento: ottobre 2026.</p>
      </main>
      <LegalFooter />
    </div>
  );
}
